import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { FILE_STATUS } from "@root/constants";
import { processDocument } from "@root/store/thunks/documentsActions";

interface UseDocumentPollingProps {
  attachedFile: any[];
  setAttachStatus: (status: "success" | "error" | null) => void;
}

/**
 * Custom hook to poll document processing status
 */
export const useDocumentPolling = ({
  attachedFile,
  setAttachStatus,
}: UseDocumentPollingProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let polling: NodeJS.Timeout | null = null;

    // Find first file with status "processing"
    const fileToPoll = attachedFile?.find(
      (file: any) => file?.status === FILE_STATUS.PROCESSING
    );

    if (fileToPoll) {
      polling = setInterval(async () => {
        try {
          const res: any = await dispatch(
            processDocument({
              id: fileToPoll?.docId,
              onSuccess: (resp: any) => resp,
              onError: () => setAttachStatus("error"),
            })
          );

          const status = res?.payload?.status;

          if (status === 3) {
            fileToPoll.status = "success";
            setAttachStatus("success");
            if (polling) clearInterval(polling);
          }
          if (status === 4) {
            fileToPoll.status = "error";
            setAttachStatus("error");
            if (polling) clearInterval(polling);
          }
        } catch {
          setAttachStatus("error");
          if (polling) clearInterval(polling);
        }
      }, 2000);
    }

    return () => {
      if (polling) clearInterval(polling);
    };
  }, [attachedFile, dispatch, setAttachStatus]);
};
